import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import IconPicker from '../../../Components/IconPicker'
import { capabilitySchema } from '../../../schemas'

export default function New({ account, accounts, navigation }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Amenity"
    >
      <BackLink href="/manage/capabilities">Back to Amenities</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={capabilitySchema}
          resource="capability"
          endpoint="/manage/capabilities"
          backLink="/manage/capabilities"
          submitLabel="Create Amenity"
          defaultValues={{
            name: '',
            icon: '',
            description: '',
            active: true
          }}
        >
          {({ control, errors, setValue, watch }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
                placeholder="e.g. Private Dining, Outdoor Terrace"
              />

              <FormFieldController
                control={control}
                name="description"
                label="Description"
                type="textarea"
                rows={2}
                errors={errors}
              />

              <div className="py-3">
                <label className="block text-sm font-medium text-gray-700 mb-2">Icon</label>
                <IconPicker
                  value={watch('icon')}
                  onChange={(val) => setValue('icon', val, { shouldDirty: true })}
                />
              </div>

              <FormFieldController
                control={control}
                name="active"
                label="Active"
                type="checkbox"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
